import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { CampaignService } from 'src/app/_services/campaign.service';
import { ICampaign, ICampaignStage } from 'src/app/model/campaign';
import { LocalStorageService } from 'src/app/_services/local-storage.service';
import { campaignListingPath, campaignTargetListingPath, getProjectNumberFromUrl } from '../campaign-scope.util';

@Component({
    selector: 'app-create-campaign-zero',
    templateUrl: './create-campaign-zero.component.html',
    styleUrls: ['./create-campaign-zero.component.scss'],
    standalone: false
})
export class CreateCampaignZeroComponent implements OnInit {
  campaign_id: number;
  campaign_details: Partial<ICampaign> = {};
  isLoaded: boolean = false;
  canEditCampaign = false;
  availableStages: ICampaignStage[] = [];
  isInEditMode:  {stageId, editMode} = {stageId: null, editMode: false};
  errorMessage: string='';

  activatedStage: ICampaignStage;
  prevStageId: number;
  userid: number;
  /**
   * This variable is used to check if the user has reached the maximum limit of active campaigns allowed.
   * If the user has reached the limit, they will not be able to activate campaign and it will move to paused state directly.
   */
  currentActiveCampaignCount: number = 0;

  projectNumber = getProjectNumberFromUrl();

  get canEditStage() {
    return Boolean(this.canEditCampaign && this.campaign_details &&
      this.campaign_details.status != 1 && this.campaign_details.status != 2);
  }

  get listingPath(): string[] {
    return campaignListingPath(this.projectNumber);
  }

  constructor(private router: Router, private route: ActivatedRoute, private campaignService: CampaignService, private localStorageService: LocalStorageService,
        private cdr: ChangeDetectorRef

  ) {
    //convert string to number
    this.campaign_id = +this.route.snapshot.paramMap.get('campaign_id');
    this.userid = this.localStorageService.getItem('userdata').userid

  }

  ngOnInit() {
    this.campaignService.getCampaignDetails(this.campaign_id).subscribe(
      (result: any) => {
        if (!result['data'].permissions?.canView) {
          this.router.navigate(campaignListingPath(this.projectNumber))
          return;
        }
      this.campaign_details = result['data'];
      this.canEditCampaign = Boolean(result['data'].permissions?.canEdit);
      this.currentActiveCampaignCount = result.activeCampaignsCount;
       this.getCampaignStages();
      } )
  }
  redirectToCreateCampaign(){
    if(this.campaign_details && this.campaign_details['status'] === 3){
      this.router.navigate(campaignListingPath(this.projectNumber));
    }
    else if(this.availableStages && this.availableStages.length){
      this.router.navigate(campaignTargetListingPath(this.campaign_id, this.projectNumber))
    }
    else
      this.router.navigate(campaignListingPath(this.projectNumber))
  }


  getCampaignStages(){
    this.campaignService.getStages(this.campaign_id).subscribe((res: any) => {
      if(res.status=='success'){
        this.availableStages = res.data.map(x=>{
          x.body = x.body.replace(/(<img src=\"{{tracker}}\">)/g, "").replace(/(<p> <a href='{{unsubscriptionUrl}}'>Click here to Unsubscribe <\/a> <\/p>)/g, "");
          x.isUnsubscribed = x?.allow_unsubscription;
          return x;
        });
        this.isLoaded = true;
      }
      else{
        this.availableStages = [];
        console.error('failed to get Stages');
      }
      this.cdr.detectChanges();
    })
  }
  showErrorMessage(){
    this.errorMessage = "Please save all active stages to proceed";
    setTimeout(()=>{
      this.errorMessage = "";
    }, 2000)
  }

  setEditPanelData(stage: ICampaignStage) {
    this.activatedStage = stage;

    //store previous campaign_stage_id from availablestages in prevStageId if activated stage is availableStages[0] store null in prevStageId
    if(this.availableStages && this.availableStages.length && this.activatedStage && this.activatedStage.campaign_stage_id && this.availableStages[0].campaign_stage_id == this.activatedStage.campaign_stage_id){
      this.prevStageId = null;
    }
    else{
      //store campaignStageId at prev index
      this.prevStageId = this.availableStages && this.availableStages.length ? this.availableStages[this.availableStages.indexOf(stage)-1]?.campaign_stage_id : null;
    }

  }
  setIsEditMode(editState: {stageId, editMode}) {
    if (!this.canEditCampaign) return;
    this.isInEditMode = editState;
  }
  updateStageValue(event: ICampaignStage){
    if (!this.canEditCampaign) return;
    this.activatedStage = event;
    this.availableStages = this.availableStages.map(x=>{
      if(x.campaign_stage_id==event.campaign_stage_id || x.campaign_stage_id==null){
        x.isUnsubscribed = x?.allow_unsubscription;
        event.body = event.body.replace(/(<img src=\"{{tracker}}\">)/g, "").replace(/(<p> <a href='{{unsubscriptionUrl}}'>Click here to Unsubscribe <\/a> <\/p>)/g, "");
        return event;
      } else return x;
    })
  }
  addNewStage(event: number){
    if (!this.canEditCampaign) return;
    if(event>0){
      let lastStage = this.availableStages[this.availableStages.length -1];
      this.availableStages = this.availableStages.concat([{
        ...this.availableStages[event-1],
        stage_name:`Follow up email - ${event}`,
        campaign_stage_id : null,
        after_id: this.availableStages[event-1].campaign_stage_id,
        body: null,
        subject: lastStage && lastStage.subject && this.campaign_details.keep_thread ? `${lastStage.subject.startsWith('Re:') ? '' : 'Re: '}${lastStage.subject}` : "",
        after_minutes: null,
        regular_days: false,
        isUnsubscribed: true,
        attachments: [],
      }]);
      // this.isInEditMode = {stageId: null, editMode: true};
      this.setEditPanelData(this.availableStages[event])
      this.isInEditMode = {stageId: this.activatedStage.campaign_stage_id, editMode: true};
    }
    else if(event==0){

      this.availableStages = [];
      this.activatedStage = null;
      this.availableStages.pop();
      this.availableStages.push({
        stage_name:`First Email - ${1}`,
        campaign_stage_id : null,
        after_id: null,
        body: null,
        subject: "",
        after_minutes: null,
        regular_days: false,
        campaign_id: null,
        created_by: null,
        is_active: null,
        created_on: null,
        updated_on: null,
        isUnsubscribed: true
      });
      this.setEditPanelData(this.availableStages[0]);
      this.isInEditMode = {stageId: null, editMode: true};
    }
    else if(event==-2){
      /**
       * Deleted existing stage
       */
      this.getCampaignStages();
    }
    else{
      this.availableStages = this.availableStages.map(x=>x);
      this.availableStages.pop();
      this.setEditPanelData(this.availableStages[this.availableStages.length + event]);
      this.isInEditMode = {stageId: this.activatedStage.campaign_stage_id, editMode: false};
    }
  }
  updateCampaignDetails(event: ICampaign){
    if (!this.canEditCampaign) return;
    if (event.keep_thread) {
      // update subject of all stages except first stage to have "Re: " prefix
      this.availableStages = this.availableStages.map((stage, index) => {
        if (index === 0) {
          return stage; // First stage remains unchanged
        }
        const firstStage = this.availableStages[0];
        const newSubject = firstStage.subject && !firstStage.subject.startsWith('Re: ') ? `Re: ${firstStage.subject}` : stage.subject;
        return {
          ...stage,
          subject: newSubject
        };
      });
    }
    this.campaign_details = {
      ...this.campaign_details,
      ...event
    }
  }

}
